import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Auth } from '../services/auth';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Auth);

  return next(req).pipe(
    catchError(error => {
      // Check for authentication errors (401 Unauthorized or 403 Forbidden)
      if (error.status === 401 || error.status === 403) {
        // Skip logout for login endpoint to prevent infinite loop
        if (!req.url.includes('/login')) {
          authService.logoutLocally();
        }
      }
      return throwError(() => error);
    })
  );
};